import React, { useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./FaqSection.css";

const FAQ_ITEMS = [
  {
    id: "convertirme",
    question: "¿Cómo puedo convertirme en anfitrión en Eslipin?",
    answer:
      "Crea tu cuenta, verifica tu identidad y publica tu propiedad siguiendo los tres pasos guiados. En menos de 10 minutos tu alojamiento queda listo para recibir reservas.",
  },
  {
    id: "cobro",
    question: "¿Cuánto me cobra Eslipin por publicar mi propiedad?",
    answer:
      "Publicar tu propiedad es gratis y Eslipin no cobra comisión sobre tus reservas: lo que ganas es tuyo.",
  },
  {
    id: "pagos",
    question: "¿Cómo se manejan los pagos por mi propiedad?",
    answer:
      "Los pagos se procesan a través del sistema de pago seguro de Eslipin y el dinero llega directo a tu cuenta, con respaldo en cada transacción.",
  },
  {
    id: "cancelacion",
    question: "¿Qué pasa si el huésped me cancela?",
    answer:
      "Aplican las políticas de cancelación definidas por el anfitrión y el respaldo del seguro Eslipin, según el caso y la anticipación de la cancelación.",
  },
];

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

function FAQItem({ item, isOpen, onToggle }) {
  return (
    <div className={s["eh-faq__item"]}>
      <button
        type="button"
        className={s["eh-faq__question"]}
        aria-expanded={isOpen}
        aria-controls={`faq-panel-${item.id}`}
        onClick={() => onToggle(item.id)}
      >
        <span className={s["eh-faq__question-text"]}>{item.question}</span>
        <div
          className={`${s["eh-chevron-container"]} ${isOpen ? s["eh-chevron-container--open"] : ""}`}
          aria-hidden="true"
        >
          <ChevronIcon />
        </div>
      </button>
      <div
        id={`faq-panel-${item.id}`}
        className={`${s["eh-faq__answer"]} ${isOpen ? s["eh-faq__answer--open"] : ""}`}
        role="region"
      >
        <p>{item.answer}</p>
      </div>
    </div>
  );
}

function FAQSection(props) {
  const { id, name } = props;
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id={id} name={name} className={s["eh-faq"]}>
      <div className={s["eh-faq__container"]}>
        <h2 className={s["eh-faq__heading"]}>Preguntas frecuentes</h2>
        <div className={s["eh-faq__list"]}>
          {FAQ_ITEMS.map((item) => (
            <FAQItem
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={handleToggle}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(FAQSection);

